/**
 * AutoMapa legal version defaults (client mirror of server registry seeds).
 * Prefer API current-document lookup for display; these IDs keep lead audit
 * compatible until consent ledger Milestone 2.
 */
export const AUTOMAPA_PRODUCT_KEY = "automapa";

export const AUTOMAPA_LEGAL_DOCUMENT_KEYS = Object.freeze({
  TERMS_OF_USE: "terms_of_use",
  PRIVACY_POLICY: "privacy_policy",
  PRIVACY_NOTICE: "privacy_notice",
  CHAT_PRIVACY_NOTICE: "chat_privacy_notice",
  DEALER_SHARING_AUTHORIZATION: "dealer_sharing_authorization",
  MARKETING_AUTHORIZATION: "marketing_authorization",
});

/** Must stay aligned with server AUTOMAPA_LEGAL_VERSIONS / seed data. */
export const AUTOMAPA_LEGAL_VERSION_DEFAULTS = Object.freeze({
  TERMS_OF_USE: "automap-terms-v1",
  PRIVACY_POLICY: "automap-privacy-v2",
  PRIVACY_POLICY_LEGACY: "automap-privacy-v1",
  PRIVACY_NOTICE: "automapa-privacy-notice-v1",
  CHAT_PRIVACY_NOTICE: "automapa-wa-consent-v2",
  CHAT_PRIVACY_NOTICE_LEGACY: "automapa-wa-consent-v1",
  DEALER_SHARING: "automapa-dealer-sharing-v1",
  MARKETING_AUTHORIZATION: "automapa-marketing-authorization-v1",
});

export const AUTOMAP_LEGAL_PATHS = Object.freeze({
  privacy: "/privacidad",
  terms: "/terminos",
});

export function mapAutomapaUiTypeToDocumentKey(uiType) {
  if (uiType === "privacy" || uiType === AUTOMAPA_LEGAL_DOCUMENT_KEYS.PRIVACY_POLICY) {
    return AUTOMAPA_LEGAL_DOCUMENT_KEYS.PRIVACY_POLICY;
  }
  if (uiType === "terms" || uiType === AUTOMAPA_LEGAL_DOCUMENT_KEYS.TERMS_OF_USE) {
    return AUTOMAPA_LEGAL_DOCUMENT_KEYS.TERMS_OF_USE;
  }
  return uiType || null;
}
